import { render, staticRenderFns } from "./AboutPage.vue?vue&type=template&id=3a7c919d&scoped=true"
import script from "./AboutPage.vue?vue&type=script&lang=js"
export * from "./AboutPage.vue?vue&type=script&lang=js"
import style0 from "./AboutPage.vue?vue&type=style&index=0&id=3a7c919d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7c919d",
  null
  
)

export default component.exports